import React from 'react'

import {
  EmployeeOperateAsCustomerUserOption,
  KegCollectionBookingsOption,
} from '../../shared/IndividualOptions'

import {
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_OPERATE_AS_CUSTOMER_USER,
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_KEG_COLLECTION_REQUEST,
} from '../../../../../../constants/permissions'
import { createYouDontHaveThesePermissionsMessage } from '../../../../../../utils/permissions'
import { isFeatureEnabled } from '../../../../../../config/featureFlags'

// CODE_COMMENTS_39
export default ({
  shouldOperateAsCustomerUserFormBeDisabled,
  shouldKegCollectionRequestFormBeDisabled,
}) => [
  <EmployeeOperateAsCustomerUserOption
    key="EmployeeOperateAsCustomerUserOption_0"
    disabledIf={shouldOperateAsCustomerUserFormBeDisabled}
    whyIsThisOptionDisabledMessage={
      shouldOperateAsCustomerUserFormBeDisabled &&
      createYouDontHaveThesePermissionsMessage({
        functionalityStringOrPermissionsMap:
          FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_OPERATE_AS_CUSTOMER_USER,
      })
    }
  />,
  isFeatureEnabled('bookings') && (
    <KegCollectionBookingsOption
      key="KegCollectionBookingsOption_0"
      disabledIf={shouldKegCollectionRequestFormBeDisabled}
      whyIsThisOptionDisabledMessage={
        shouldKegCollectionRequestFormBeDisabled &&
        createYouDontHaveThesePermissionsMessage({
          functionalityStringOrPermissionsMap:
            FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_KEG_COLLECTION_REQUEST,
        })
      }
    />
  ),
]
